import {
  GlobalStyle,
  ModalProvider,
  ToastContextProvider,
} from '@resideo/blueprint-react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from 'App';
import GlobalVisualProvider from 'components/common/GlobalVisualProvider';
import GlobalCommonStylesShim from 'components/global/GlobalCommonStylesShim';
import LanguageProvider from 'components/global/LanguageProvider';
import SentryUser from 'components/global/SentryUser';
import ThemePreferencesProvider from 'components/global/ThemePreferencesProvider';
import { FeatureFlagsProvider } from 'context/FeatureFlags';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import ReactQueryProvider from 'utils/ReactQueryProvider';
import { Titled } from 'react-titled';

import { local } from 'utils/storage';

const Root = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const prefLocale = local.getItem('pref-locale');
    if (prefLocale && prefLocale !== 'en') {
      i18n.changeLanguage(prefLocale);
    }
  }, [i18n]);

  return (
    <ReactQueryProvider>
      <AuthProvider>
        <LanguageProvider />
        <SentryUser />
        <FeatureFlagsProvider>
          <ThemePreferencesProvider>
            <Titled title={() => t('title')}>
              <GlobalStyle />
              <GlobalCommonStylesShim />
              <GlobalVisualProvider>
                <ToastContextProvider>
                  <ModalProvider>
                    <Outlet />
                  </ModalProvider>
                </ToastContextProvider>
              </GlobalVisualProvider>
            </Titled>
          </ThemePreferencesProvider>
        </FeatureFlagsProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </ReactQueryProvider>
  );
};

export default Root;
